import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { BaseApiService } from '../base.api-service';

const IMPERSONATION_PATH = '/auth/impersonation';

@Injectable({
  providedIn: 'root',
})
export class ImpersonationApiService extends BaseApiService {
  /** Échange le code à usage unique transmis par le backoffice contre le jeton. */
  redeem(handoffCode: string): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(
      environment.apiBasePaths.general + IMPERSONATION_PATH + '/redeem',
      { handoff_code: handoffCode }
    );
  }

  /** Trace la fin de la prise d'identité courante. */
  end(): Observable<void> {
    return this.http.post<void>(
      environment.apiBasePaths.general + IMPERSONATION_PATH + '/end',
      {}
    );
  }
}
